import { CheckBoxBlankIcon, CheckBoxIcon, CheckBoxIndeterminateIcon } from 'assets/icons';
import clsx from 'clsx';
import { ChangeEventHandler, ReactElement } from 'react';

interface CheckboxProps {
  checked: boolean;
  className?: string;
  disabled?: boolean;
  indeterminate?: boolean;
  onClick?: () => void;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  ariaLabel?: string;
  label?: string;
}

export function Checkbox({
  checked,
  className,
  disabled,
  indeterminate,
  onClick,
  onChange,
  ariaLabel,
  label,
}: Readonly<CheckboxProps>): ReactElement<CheckboxProps> {
  return (
    <label className={clsx(`${className}`, { 'opacity-50': disabled })}>
      {checked ? (
        <CheckBoxIcon className="size-6 text-green-200" />
      ) : indeterminate ? (
        <CheckBoxIndeterminateIcon className="size-6 text-green-200" />
      ) : (
        <CheckBoxBlankIcon className="size-6" />
      )}
      <input
        type="checkbox"
        checked={onChange ? checked : undefined}
        defaultChecked={!onChange ? checked : undefined}
        className="appearance-none"
        disabled={disabled}
        onClick={onClick}
        onChange={onChange}
        aria-label={ariaLabel}
        aria-checked={indeterminate ? 'mixed' : checked}
      />
      {label}
    </label>
  );
}
